import { DateTime } from "luxon";
import { FaArrowRight, FaMapMarkerAlt } from "react-icons/fa";
import { IoMdOpen } from "react-icons/io";
import { OrderChannelIcon } from "./OrderChannelIcon";
import { useSWRConfig } from "swr"
import { ENUM_PAYMENT } from "../../../components/Modals/OrderIfood";

export function CardIfood ({ id, numOrder, name, address, createdAt, orderType, orderTiming, status, pricing, selectOrder, next, order }) {
  const date = DateTime.fromISO(createdAt).toFormat("dd/MM HH:mm")
  const textMethodDelviery = orderType === 'DELIVERY' ? 'Entrega' : 'Retirada'
  const { mutate } = useSWRConfig()

  const canceled = ['cancelado'].includes(status)
  const isRequestCancel = order?.statusIfood === 'HANDSHAKE_DISPUTE'


  let paymentMethod = ''
  const pedido = order?.payload?.length > 0 ? order.payload[0] : {}
  const isOnline = pedido?.payments?.methods?.[0]?.type === 'ONLINE'

  function openCardWithKeyboard(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      selectOrder()
    }
  }

  try {
    paymentMethod = ENUM_PAYMENT[pedido?.payments?.methods[0]?.method]

    if (isOnline) {
      paymentMethod = 'Ifood'
    }

    if (pedido.payments.prepaid > 0) {
      paymentMethod = 'Ifood'
    }
    
  } catch (error) { }

  return (
    <div
      key={id}
      className={`order-card order-card-ifood ${canceled ? 'order-card-canceled' : ''}`}
      onClick={selectOrder}
      onKeyDown={openCardWithKeyboard}
      role="button"
      tabIndex={0}
      aria-label={`Abrir pedido iFood ${numOrder}`}
    >
      {isRequestCancel && (
        <div className="order-ifood-warning">
          <div className="spinner-grow text-warning spinner-grow-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div className="order-card-main">
        <div className="order-card-header">
          <div className="order-card-identity">
            <OrderChannelIcon channel="ifood" />
            <div className="order-card-identity-text">
              <strong className="order-card-number">#{numOrder}</strong>
              <span className="order-card-date">{date}</span>
            </div>
          </div>
          <div className="order-card-price">
            <strong>{pricing}</strong>
            <span>{paymentMethod}</span>
          </div>
        </div>
        <p className="order-card-customer">{name}</p>

        <div className="order-card-delivery">
          <FaMapMarkerAlt size={13} />
          <span>{textMethodDelviery === 'Retirada' ? 'Retirada no local' : address}</span>
        </div>

        <div className="order-card-actions">
          <button type="button" className="order-icon-button" title="Ver pedido" aria-label="Ver pedido" onClick={(event) => {
            event.stopPropagation()
            selectOrder()
          }}>
            <IoMdOpen size={17} />
          </button>

          {next && (
            <button className="order-next-button" onClick={async (event) => {
              event.stopPropagation()
              await next()
              await mutate('/ifood/orders')
            }}>
              {status === 'aguardando' ? 'Aceitar' : 'Avançar'} <FaArrowRight size={13} />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
